import React, { ReactElement } from 'react';
import Link, { LinkProps } from 'next/link';

interface IProtectedLink extends LinkProps {
    disabled?: boolean
    children?: ReactElement
}
export const ProtectedLink = ({ disabled, children, ...rest }: IProtectedLink) => {
    if(disabled) {
        return <>{children}</>;
    }
    return (
        <Link {...rest}>
            {children}
        </Link>
    );
};
